import React from '../helpers/react';
import { connect } from '../helpers/composeReducer.js';
import { trigger } from '../helpers/events.js';
import classList from 'ereader-core/dist/classList.js';
import {getHookClass} from '../helpers/cssHooks.js';

export const NoSolution = React.createClass({
    triggerCTA : function() {
        trigger('noSolutionCTA', this.props.problemId);
    },

    getHeader : function() {
        let title = this.props.getDef('solution.title', {}, {
            problem_exists: this.props.problem_exists
        });

        return (<header key='header'><h3>
            {title}
        </h3></header>)
    },

    getCTA : function() {
        return [
                <p key='variant-text'>{ this.props.getDef('no-solution.qa') }</p>,
                <button key='variant-cta' className='simple-button cta ask-expert-no-sol' onClick={this.triggerCTA}>{this.props.getDef('no-solution.ask-expert-btn')}</button>
            ];
    },

    render :  function() {
        const header = this.getHeader(),
            content_variant = this.props.empty_problem_show_cta
                ? this.getCTA()
                : <p>{this.props.getDef('no-solution.no-cta')}</p>;

        let mainClass = classList('solution', getHookClass('NoSolution'));
        return (
            <section className={mainClass}>
                { header }
                <section className='no-solution'>
                    <p>{ this.props.getDef('no-solution.title') }</p>
                    { content_variant }
                </section>
            </section>
        );

    }
});

export function mapStateToProps(state){
    const problem = state.problem;
    return {
        ...problem,
        empty_problem_show_cta : state.options.empty_problem_show_cta,
        getDef : state.helpers.getDef
    };
}

export default connect(mapStateToProps)(NoSolution);



// WEBPACK FOOTER //
// ./src/components/NoSolution.js